// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import Trophy_goldSvg from "./trophy_gold.svg";
import Trophy_glassSvg from "./trophy_glass.svg";
import Trophy_bronzeSvg from "./trophy_bronze.svg";
import Trophy_silverSvg from "./trophy_silver.svg";

var trophyGlass = Trophy_glassSvg;

var trophyBronze = Trophy_bronzeSvg;

var trophySilver = Trophy_silverSvg;

var trophyGold = Trophy_goldSvg;

function WordFlyersTrophies$Gold(props) {
  return React.createElement("img", {
              alt: "Gold Trophy",
              src: trophyGold
            });
}

var Gold = {
  make: WordFlyersTrophies$Gold
};

function WordFlyersTrophies$Silver(props) {
  return React.createElement("img", {
              alt: "Silver Trophy",
              src: trophySilver
            });
}

var Silver = {
  make: WordFlyersTrophies$Silver
};

function WordFlyersTrophies$Bronze(props) {
  return React.createElement("img", {
              alt: "Bronze Trophy",
              src: trophyBronze
            });
}

var Bronze = {
  make: WordFlyersTrophies$Bronze
};

function WordFlyersTrophies$Glass(props) {
  return React.createElement("img", {
              alt: "Glass Trophy",
              src: trophyGlass
            });
}

var Glass = {
  make: WordFlyersTrophies$Glass
};

function trophyToIcon(trophy) {
  switch (trophy) {
    case "Glass" :
        return React.createElement(WordFlyersTrophies$Glass, {});
    case "Bronze" :
        return React.createElement(WordFlyersTrophies$Bronze, {});
    case "Silver" :
        return React.createElement(WordFlyersTrophies$Silver, {});
    case "Gold" :
        return React.createElement(WordFlyersTrophies$Gold, {});
    
  }
}

export {
  trophyGlass ,
  trophyBronze ,
  trophySilver ,
  trophyGold ,
  Gold ,
  Silver ,
  Bronze ,
  Glass ,
  trophyToIcon ,
}
/* trophyGlass Not a pure module */
